<template>
	<div class="NavBar" style="pointer-events: none;">
		<div>
<!-- TODO: move styles to style block -->
			<div class="appInfo">
				<v-avatar size="32px" :color="color" class="appAvatar">
					<v-img
						:src="this.selectedComponent?.fields?.icon?.de?.fields?.file?.de?.url ?? ''"
						style="width: 20px; height: 20px; opacity: 0.5; margin: 10px;"
					/>
				</v-avatar>
				<div class="appDetails">
					<div style="font-size: 9.5pt !important; color: #999999; line-height: 11px;">
						MyServices
						<span style="opacity: 0.5;" :title="$store.getters.featureBranch" @click="handleVersionClick($event)">{{this.version}}</span>
					</div>
					<div style="white-space: nowrap; width: 180px; overflow: hidden; text-overflow: ellipsis;" :style="[componentStyle]">{{ getComponentName() }}</div>
				</div>
				<v-spacer/>
				<v-icon v-if="!isStandalone" color="#aaa" class="goToDashboardIcon" @click="showDashboard">mdi-view-grid</v-icon>
			</div>

			<!-- Profile / Logout / Language Menu -->
			<div v-if="isStandalone" id="profileComponent" style="position: absolute; inset: 0; left: auto; width: 64px; height: 64px; background: white; pointer-events: all; padding: 18px 22px;">
				<v-icon color="#666" style="cursor:pointer" @click="$router.push('/')">mdi-logout</v-icon>
			</div>
			<div v-if="!isStandalone" id="profileComponent" style="position: absolute; inset: 0; left: auto; width: 64px; height: 64px; background: white; pointer-events: all;">
				<v-menu style="z-index:1000">
					<template v-slot:activator="{ props }">
						<div>
							<v-btn v-bind="props" id="btnUserProfile" icon elevation="0" style="background:none !important; border:0 !important; margin-left: 10px; margin-right: -10px; margin-top: 7px;">
								<img src="@/assets/icons/user.svg" width="28" height="28" style="cursor: pointer; border-radius: 20px; outline: 0 dotted rgb(255, 51, 102);"
									:style="{
										'outline-width': tokenExpiresInSeconds < 600 ? '4px' : '0px',
									}"
								/>
							</v-btn>
						</div>
					</template>
					<v-list>
						<v-list-item style="cursor: pointer; background: rgb(255, 51, 102); color: white;" v-if="tokenExpiresInSeconds < 600">
							<v-icon color="white">mdi-clock</v-icon>
							logout in {{ tokenExpiresInSeconds }} sec
						</v-list-item>
						<v-list-item @click="setLocale('de')" v-if="localeVisible">
							<template #prepend>
								<LanguageFlag modelValue="de" style="margin-right:5px" />
							</template>
							Deutsch
						</v-list-item>
						<v-list-item @click="setLocale('en')" v-if="localeVisible">
							<template #prepend>
								<LanguageFlag modelValue="en" style="margin-right:5px" />
							</template>
							English
						</v-list-item>
						<v-list-item @click="setLocale('fr')" v-if="localeVisible">
							<template #prepend>
								<LanguageFlag modelValue="fr" style="margin-right:5px" />
							</template>
							Français
						</v-list-item>
						<v-list-item @click="setLocale('it')" v-if="localeVisible">
							<template #prepend>
								<LanguageFlag modelValue="it" style="margin-right:5px" />
							</template>
							Italiano
						</v-list-item>
						<v-list-item @click="setLocale('nl')" v-if="localeVisible">
							<template #prepend>
								<LanguageFlag modelValue="nl" style="margin-right:5px" />
							</template>
							Nederlands
						</v-list-item>

						<v-divider v-if="haveUser" />
						<v-list-item class="accountAction" style="cursor: default;" v-if="haveUser && this.loggedInUser?.fields" data-cy="userEmail">
							<v-icon>mdi-account</v-icon>
							{{ this.$store.state.loggedInUser.fields.email.de }}
						</v-list-item>
						<v-list-item class="accountAction" v-if="haveUser && userIsImpersonating" @click="exitImpersonation()" data-cy="isImpersonation">
							<v-icon>mdi-drama-masks</v-icon>
							AS: {{ this.$store.state.selectedServiceProvider?.fields?.title?.de }}
							<v-icon style="float: right;">mdi-logout</v-icon>
						</v-list-item>
						<!--
							TODO: also set the linked sp do this!
							v-if="item.addl && item.addl.isHomebase && item.fields.mainAccountId && item.fields.mainAccountId.de"
						-->
						<v-list-item class="accountAction" v-if="canImpersonate" @click="impersonate($store.state.selectedServiceProvider)" data-cy="enterImpersonation">
							<v-icon>mdi-login</v-icon>
							OP AS: {{ this.$store.state.selectedServiceProvider?.fields?.title?.de }}
						</v-list-item>

						<v-divider v-if="haveUser" />
						<v-list-item v-if="haveUser" @click="showChangePasswordDialog()">
							<v-icon>mdi-key</v-icon>
							{{ $t('text.changePassword') }}
						</v-list-item>
						<v-list-item @click="openUrl('https://www.alturos.com/')">
							<v-icon>mdi-text-box-outline</v-icon>
							Imprint
						</v-list-item>
						<v-list-item @click="openUrl('http://www.alturos.com/privacy-statement/')">
							<v-icon>mdi-text-box-outline</v-icon>
							Privacy Policy
						</v-list-item>

						<v-list-item id="logout" data-cy="logout" v-if="haveUser" @click="logout()">
							<v-icon>mdi-lock</v-icon>
							{{ $t('text.logout') }}
						</v-list-item>
					</v-list>
				</v-menu>
			</div>

		<teleport to="body">
			<div v-show="showChangePassword" class="dialogBackdrop" @click.self="closeChangePasswordDialog()">
				<div class="dialogDiv password-change">
					<div class="password-change-header">
						<h3 class="password-change-title">{{ $t('text.changePassword') }}</h3>
						<v-btn icon variant="text" size="small" class="password-change-close" @click="closeChangePasswordDialog()">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
					<v-alert v-if="errorTitle !== ''" type="error" closable flat class="notification" prominent v-model="errorAlertVisible"><span v-html="errorMessages"></span></v-alert>
					<v-alert v-if="successTitle !== ''" type="success" closable flat class="notification" prominent v-model="successAlertVisible"><span v-html="successMessages"></span></v-alert>
					<v-form>
						<v-row>
							<v-col>
								<div class="password-change-container">
									<v-form>
										<v-label class="password-change-label">{{ $t('text.currentPassword') }} ({{ $t('text.required') }})</v-label>
										<input type="text" style="display: none;" name="username" autocomplete="username" />
										<v-text-field
											:type="showCurrentPassword ? 'text' : 'password'"
											variant="outlined"
											density="compact"
											v-model="currentPassword"
											autocomplete="off"
											:placeholder="$t('text.enterCurrentPassword')"
											:error-messages="currentPasswordErrors"
											@update:modelValue="onCurrentPasswordInput"
											@blur="v$.currentPassword.$touch()"
											required
										>
											<template #append-inner>
												<v-icon @click="showCurrentPassword = !showCurrentPassword" tabindex="-1" style="cursor: pointer">
													{{ showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye' }}
												</v-icon>
											</template>
										</v-text-field>
										<v-label class="password-change-label">{{ $t('text.newPassword') }} ({{ $t('text.required') }})</v-label>
										<v-text-field
											:type="showNewPassword ? 'text' : 'password'"
											variant="outlined"
											density="compact"
											v-model="password"
											autocomplete="new-password"
											:placeholder="$t('text.enterNewPassword')"
											:error-messages="passwordErrors"
											@update:modelValue="v$.password.$touch()"
											@blur="v$.password.$touch()"
											required
										>
											<template #append-inner>
												<v-icon @click="showNewPassword = !showNewPassword" tabindex="-1" style="cursor: pointer">
													{{ showNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}
												</v-icon>
											</template>
										</v-text-field>
										<v-label class="password-change-label">{{ $t('text.repeatPassword') }} ({{ $t('text.required') }})</v-label>
										<v-text-field
											:type="showRepeatPassword ? 'text' : 'password'"
											variant="outlined"
											density="compact"
											v-model="repeatPassword"
											autocomplete="new-password"
											:placeholder="$t('text.enterNewPassword')"
											:error-messages="repeatPasswordErrors"
											@update:modelValue="v$.repeatPassword.$touch()"
											@blur="v$.repeatPassword.$touch()"
											required
										>
											<template #append-inner>
												<v-icon @click="showRepeatPassword = !showRepeatPassword" tabindex="-1" style="cursor: pointer">
													{{ showRepeatPassword ? 'mdi-eye-off' : 'mdi-eye' }}
												</v-icon>
											</template>
										</v-text-field>
									</v-form>
								</div>
								<v-row class="password-change-buttons">
									<v-btn id="btnCancel" class="password-change-btn-cancel" elevation="0" @click="closeChangePasswordDialog()">{{ $t('text.cancel') }}</v-btn>
									<v-btn id="btnChangePassword" class="password-change-btn-submit" elevation="0" :disabled="currentPassword === '' || password === '' || repeatPassword === ''" @click="changePassword()">{{ $t('text.changePassword') }}</v-btn>
								</v-row>
							</v-col>
						</v-row>
					</v-form>
				</div>
			</div>
		</teleport>
	</div>

    <!-- System Bar - Impersonation -->
    <v-system-bar v-if="showImpersonationInfo && !showSystemNotification()" color="rgb(0, 174, 239)" class="system-bar" style="top: auto; bottom: 0;">
          <v-spacer></v-spacer>      
          <v-icon class="text-white" style="margin-right: 4px;">mdi-drama-masks</v-icon>
          <span class="text-white"> 
            {{ $t('text.currentlyViewingAs') }} 
            {{ $t('text.serviceProvider') }} 
            {{ impersonatedName }}
            ({{ impersonatedEmail }})
          </span>
          <v-spacer></v-spacer>
    </v-system-bar>

     <!-- System Bar - System Notification -->
    <v-system-bar v-if="showSystemNotification()" color="#f27826" class="system-bar">
          <v-spacer></v-spacer>      
          <v-icon class="text-white">mdi-alert-circle</v-icon>
          <span class="text-white"> 
            {{ systemNotification[selectedLocale] }}
          </span>
          <v-spacer></v-spacer>
    </v-system-bar>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import Common from '@/mixins/Common.vue'
import TokenAware from '@/mixins/TokenAware.vue'
import LanguageFlag from './LanguageFlag.vue'
import Dialog from '@/components/common/Dialog.vue'
import { version } from '../../../package.json'
import { translationUtil } from '@/utils/translation-util'
import Toast from '@/mixins/Toast.vue'

export default {
	components: { LanguageFlag, Dialog },
	name: 'NavBar',
	mixins: [ Common, TokenAware, Toast ],
	validations() {
		return {
			currentPassword: { required, minLength: minLength(8) },
			password: { required, minLength: minLength(8) },
			repeatPassword: { required, minLength: minLength(8), sameAsPassword: sameAs(this.password) },
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() { return {
		version: '1.0.0',
		haveComponent: false,
		haveUser: false,
		showChangePassword: false,
		showCurrentPassword: false,
		showNewPassword: false,
		showRepeatPassword: false,
		currentPassword: '',
		password: '',
		repeatPassword: '',

		title: '',

		currentPasswordApiError: '',
		errorTitle: '',
		errorDetail: '',
		errorAlertVisible: false,
		successTitle: '',
		successDetail: '',
		successAlertVisible: false,

		componentStyle: {
			color: "#999999",
			fontWeight: "bold",
			fontSize: "13pt !important"
		},

		color: '#bfbfbf',
		icon: '',
		selectedComponent: {},
		user: {},
		systemNotification: null,
	}},
  computed: {
    impersonatedName() {
      return this.$store.state.impersonatedServiceProvider?.fields?.title?.[this.selectedLocale]
    },
    impersonatedEmail() {
      return this.$store.state.impersonatedServiceProvider?.fields?.mainUserAccount?.fields?.email?.de
    },
    canImpersonate() {
      let impersonateEnabled = false

      if (this.haveUser &&
          !this.userIsImpersonating &&
          this.userIsHomeOperator &&
          (this.$store.state.selectedServiceProvider?.fields?.mainAccountId?.de ||
          this.$store.state.selectedServiceProvider?.fields?.userAccount?.de?.sys?.id)) {

          impersonateEnabled = true

      }

      return impersonateEnabled
    },
    localeVisible() {
      return this.$route.path === '/' || this.$route.path === '/dashboard' || this.$route.path === '/registration' || this.$route.path === '/forgotPassword'
    },
    errorMessages() {
      return ' <span style="font-size:14pt;font-weight:bold;"> ' + this.errorTitle + ' </span><br> ' + this.errorDetail
    },
    successMessages() {
      return ' <span style="font-size:14pt;font-weight:bold;"> ' + this.successTitle + ' </span><br> ' + this.successDetail
    },
    componentColour() {
      return this.selectedComponent.color
    },
    currentPasswordErrors() {
      const errors = []
      if (this.currentPasswordApiError) errors.push(this.currentPasswordApiError)
      const { $dirty, required, minLength } = this.v$.currentPassword

      if (!$dirty && !this.currentPasswordApiError) return errors

      if (required.$invalid) errors.push(this.$t('text.passwordRequired'))
      if (minLength.$invalid) errors.push(this.$t('text.passwordMinChars'))

      return errors
    },
    passwordErrors() {
      const errors = []
      const { $dirty, required, minLength } = this.v$.password

      if (!$dirty) return errors

      if (required.$invalid) errors.push(this.$t('text.newPasswordRequired'))
      if (minLength.$invalid) errors.push(this.$t('text.newPasswordMinChars'))

      return errors
    },
    repeatPasswordErrors() {
      const errors = []
      const { $dirty, sameAsPassword } = this.v$.repeatPassword

      if (!$dirty) return errors

      if (sameAsPassword.$invalid) errors.push(this.$t('text.repeatPasswordSame'))
      if (required.$invalid) errors.push(this.$t('text.repeatPasswordRequired'))
      if (minLength.$invalid) errors.push(this.$t('text.repeatPasswordMinChars'))

      return errors
    },
		loggedInUser() {
			return this.$store.state.loggedInUser
		},
		isStandalone() {
			return this.$route.path.includes('/sa-')
		},
	},
	watch: {
		'$store.state.selectedLocale': function() {
			this.selectedLocale = this.$store.state.selectedLocale
		},
		'$store.state.selectedComponent': function() {
			this.selectedComponent = this.$store.state.selectedComponent
		},
		selectedComponent() {
			this.haveComponent = this.selectedComponent?.fields
			this.color = this.selectedComponent?.fields?.colour?.de ?? '#bfbfbf'
			this.componentStyle.color = this.selectedComponent?.fields?.colour?.de ?? '#bfbfbf'
			this.icon = this.selectedComponent?.fields ? this.getAssetUrl(this.selectedComponent.fields.icon.de) : ''
		},
		errorAlertVisible() {
			if (!this.errorAlertVisible) return
			setTimeout(this.closeAlert, 3000)
		},
		successAlertVisible() {
			if (!this.successAlertVisible) return
			setTimeout(this.closeAlert, 3000)
		},
		loggedInUser() { this.updateUserState() },
	},
	methods: {
		async setLocale(locale) {
			this.$root.$i18n.locale = locale
			this.$vuetify.locale.current = locale
			await this.$store.commit('setSelectedLocale', locale)
		},
		showChangePasswordDialog() {
			this.currentPassword = ''
			this.password = ''
			this.repeatPassword = ''
			this.currentPasswordApiError = ''
			this.showCurrentPassword = false
			this.showNewPassword = false
			this.showRepeatPassword = false
			this.errorTitle = ''
			this.errorDetail = ''
			this.errorAlertVisible = false
			this.successTitle = ''
			this.successDetail = ''
			this.successAlertVisible = false
			this.v$.$reset()
			this.showChangePassword = true
		},
		closeChangePasswordDialog() {
			this.showChangePassword = false
		},
		onCurrentPasswordInput() {
			this.currentPasswordApiError = ''
			this.v$.currentPassword.$touch()
		},
		async changePassword() {
			this.currentPasswordApiError = ''
			this.v$.$touch()
			if (this.v$.$invalid) return

			let emailAddress = this.$store.state.isImpersonation ? this.$store.state.selectedServiceProvider.fields.mainUserAccount.email : this.loggedInUser.fields.email.de

			var data = {
				email: emailAddress,
				currentPassword: this.currentPassword,
				password: this.password,
			}

			try {
				await this.$httpPost('/reset-password', data)
				this.successTitle = this.$t('text.PASSWORD_CHANGED')
				this.successDetail = this.$t('text.passwordChangeSuccess')
				this.successAlertVisible = true
			}
			catch (error) {
				const message = error?.error || error?.message || this.$t('text.invalidCurrentPassword') || 'Invalid current password'
				this.currentPasswordApiError = typeof message === 'string' ? message : 'Invalid current password'
			}
		},
		async getSystemNotification() {
			try {
				this.systemNotification = await this.$httpGet('/system-notification')
			}
			catch (error) {
				// silent ignore
			}
		},
		showSystemNotification() {
			return this.systemNotification && this.$route.path === '/dashboard'
		},
		async logout() {
			try {
				await this.$httpPost('/logout')
			}
			catch (error) {}

			this.haveUser = false
			this.$emit("show-login", '')
		},
		showDashboard() {
			this.$emit("show-dashboard")
		},
		showComponent() {
			this.$emit("show-component")
		},
		getComponentName() {
			if (this.selectedComponent) {
				let componentName = this.selectedComponent?.fields?.title?.[this.selectedLocale] ?? ''
				if (!componentName) return 'Dashboard'
				return componentName
			}
		},
		closeAlert() {
			if (this.errorAlertVisible) {
				this.errorAlertVisible = false
			}
			else if (this.successAlertVisible) {
				this.successAlertVisible = false
				this.showChangePassword = false
			}
		},
		openUrl(url) {
			window.open(url, '_blank')
		},
		updateUserState() {
			if (this.loggedInUser && this.loggedInUser.hasOwnProperty("kc_token")) {
				this.selectedComponent = this.$store.state.selectedComponent
				this.user = this.loggedInUser
				this.haveUser = true

				this.getSystemNotification()
			}
			else {
				this.selectedComponent = {}
				this.user = {}
				this.haveUser = false
			}
		},
		async handleVersionClick(event) {
			// Cmd+click (Mac) or Ctrl+click (Windows) toggles developer mode (Skiline widget)
			if (event.metaKey || event.ctrlKey) {
				this.$emit('toggle-developer-mode')
				return
			}

			if (!event.shiftKey) {
				return
			}

			try {
				await this.$store.commit('setTranslations', null)

				await translationUtil.load(this.$store)

				// Recreate i18n instance with new translations
				const newI18n = translationUtil.createI18n(this.$store)

				this.showSuccessToast('Translations refreshed successfully!', true)
				// refresh page to force reload of the i18n instance to apply the new translations
				window.location.reload()
			}
			catch (error) {
				console.error('Failed to refresh translations:', error)
				this.showErrorToast('Failed to refresh translations', true)
			}
		},
	},
	async mounted() {
		this.$root.$i18n.locale = this.selectedLocale
		this.$vuetify.locale.current = this.selectedLocale
		this.version = version
		this.updateUserState()
	},
}
</script>

<style scoped>
.NavBar {
	--v-input-control-height: 45px;
}
.v-app-bar.v-app-bar--fixed {
  border-bottom: 1px solid #b4c3ca !important;
}
.gradient {
  background: linear-gradient(0deg, #efefef 0%, #ffffff 100%);
  border: thin #dddddd;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.v-list-item {
	cursor: pointer !important;
}

.v-list-item__title { font-size: 12pt !important; }
.v-list-item__title .v-icon { margin-right: 5px; }
.dialogBackdrop {
	--space-xxl: 32px;
	position: fixed;
	inset: 0;
	z-index: 1999;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	padding: var(--space-xxl, 32px);
	background: rgba(0, 0, 0, 0.50);
	box-sizing: border-box;
}

.dialogDiv.password-change {
	position: relative;
	width: min(560px, calc(100vw - 64px));
	min-width: min(320px, calc(100vw - 64px));
	background: #ffffff;
	border-radius: 8px;
	border: thin solid #cfcfcf;
	box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.2);
	padding: 0;
	color: #333;
	z-index: 2000;
	pointer-events: auto;
}

.password-change-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 32px;
	border-bottom: 1px solid #eee;
}

.password-change-title {
	margin: 0;
	font-size: 20px;
	font-weight: bold;
	color: #000;
}

.password-change-close {
	min-width: unset;
}

.password-change-label {
	color: #333;
	font-size: 15px;
}

.dialogDiv.password-change .v-col {
	padding: 0;
}

.dialogDiv.password-change .v-row {
	margin: 0;
}

.dialogDiv.password-change .v-row .password-change-container {
	padding: 32px;
}

.dialogDiv.password-change .password-change-container .v-text-field {
	margin-bottom: 16px;
}

.dialogDiv.password-change .v-row .password-change-buttons {
	justify-content: flex-end;
	gap: 12px;
	padding: 20px 32px;
	border-top: 1px solid #eee;
}

.password-change-btn-cancel {
	background: #fff;
	color: #333;
	border: 1px solid #cfcfcf;
}

.password-change-btn-submit {
	background: #4caf50;
	color: #fff;
}

.password-change-btn-submit:hover:not(:disabled) {
	background: #43a047;
}

.accountAction { background-color: #fafafa; }
.accountAction .v-list-item__title { font-size: 12px !important; }

.theme--light.v-divider {
  border-color: #b4c3ca !important;
  border-width: 0.5px !important;
  opacity: 1 !important;
  z-index: 1000;
}
/*
.navbarComponent { 
  width:100%;
  height: 62px;
  pointer-events: none;
}
*/

.appInfo { position: absolute; inset: 0; right: auto; width: 300px; height: 100%; display: flex; gap: 8px; align-items: center; padding: 15px; background: white; pointer-events: all; }
.goToDashboardIcon { cursor: pointer; }

@media screen and (max-width: 660px) {
	.appAvatar { display: none; }
	.appDetails { display: none; }
	.appInfo { width: 60px; margin-left: -10px; }
}
</style>
